import styled from 'styled-components'
import { iPadDown, iPadUp } from '../../styles/mediaQueries'
import { DolaThemeProps } from '../../styles/types'
import theme from '../../styles/theme'
import buttonTheme from '../Button/styles/theme'

interface ContentWrapperProps {
  overrides?: string
}

export const ContentWrapper = styled.div<ContentWrapperProps>`
  padding: 0 2.35vw;
  padding-bottom: 8vw;

  ${iPadDown} {
    padding: 0 4.83vw;
    padding-bottom: 8vw;
  }

  ${({ overrides }) => overrides || ''}
`

interface HeaderFillerProps {
  subheader: boolean
}

export const HeaderFiller = styled.div<HeaderFillerProps>`
  height: ${({ subheader }) => (subheader ? '13.1vw' : '7.1vw')};

  ${iPadDown} {
    height: ${({ subheader }) => (subheader ? '42.7vw' : '22.5vw')};
  }
`

interface ScreenProps extends DolaThemeProps {
  hasNotification: boolean
}

export const Screen = styled.div<ScreenProps>`
  color: ${({ dolaTheme }) => theme[dolaTheme].text};
  max-height: 100vh;
  overflow: auto;
  ${({ hasNotification }) =>
    hasNotification
      ? `
    display: none;
  `
      : ''}

  ${iPadDown} {
    max-height: 75vh;
  }

  .footer {
    color: ${({ dolaTheme }) =>
      dolaTheme === 'light'
        ? theme.light.text
        : buttonTheme.dark.disabled.text};
  }

  .desktop-only {
    ${iPadDown} {
      display: none;
    }
  }

  .mobile-only {
    ${iPadUp} {
      display: none;
    }
  }
`
